export function renderWaterBackground(k) {
    k.add([
        k.rect(k.width(), k.height()),
        k.pos(0, 0),
        k.color(71, 171, 169),
        k.z(-100),
        "water_base"
    ]);
}